import { msg } from "@lingui/core/macro";

export const expiresInNumberOfDaysRuleMessages = {
	name: msg({ message: "Expires In Number of Days" }),
	description: msg({ message: "Permit expiry date is set a fixed number of days after start" }),
	errors: {
		noEndTime: msg({ message: "Permit must have an end time to expire after {numberOfDays} days" }),
	},
} as const;
